import * as types from '../actions/external-integration-actions-types';


const REVOKE_EXTERNAL_OAUTH_INITIAL_STATE = {
	isLoading: false,
	results: {},
	error: '',
};

export function revokeExternalProviderOauthReducer(state = REVOKE_EXTERNAL_OAUTH_INITIAL_STATE, action) {
	switch (action.type) {
		case types.GENERAL_REVOKE_OAUTH_REQUEST:
			return { ...state, isLoading: true, results: [] };
		case types.GENERAL_REVOKE_OAUTH_SUCCESS:
			return { ...state, isLoading: false, results: action.payload };
		case types.GENERAL_REVOKE_OAUTH_FAILURE:
			return { ...state, isLoading: false, error: 'Error while trying to revoke external provider Oauth' };
		default:
			return state;
	}
}